import { useState, useEffect, useCallback } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VMAP = { V1: 'v1_relevo', V2: 'v2_internacionalizacion', V3: 'v3_financiera', V4: 'v4_crecimiento' };
const VLABEL = { V1: 'V1 Relevo', V2: 'V2 Internac.', V3: 'V3 Financiera', V4: 'V4 Crecimiento' };
const RMAP = { R1: 'r1', R2: 'r2', R3: 'r3', R4: 'r4', R5: 'r5', R6: 'r6' };

export default function Cobertura({ token, onCellClick }) {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    const res = await fetch(`${BACKEND_URL}/api/admin/cobertura`, { headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) setData(await res.json());
  }, [token]);
  useEffect(() => { load(); }, [load]);

  if (!data) return <div className="text-white/30 text-sm py-12 text-center">Cargando cobertura…</div>;

  const rows = Object.keys(VMAP);
  const cols = Object.keys(RMAP);

  const cellStyle = (V, R) => {
    const cell = data.matriz[V][R];
    const def = data.deficit[V][R];
    let cls = 'bg-emerald-400/10 text-emerald-300';
    if (cell.crit === '—') cls = 'bg-white/[0.03] text-white/30';
    else if (def > 0) cls = 'bg-amber-400/10 text-amber-300';
    const border = cell.crit === 'C' ? 'border-2 border-white/25' : 'border border-white/5';
    return `${cls} ${border}`;
  };

  return (
    <div>
      <div className="overflow-x-auto" data-testid="cobertura-grid">
        <table className="border-collapse">
          <thead>
            <tr>
              <th className="p-2"></th>
              {cols.map((R) => <th key={R} className="p-2 text-white/50 text-xs font-medium">{R}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((V) => (
              <tr key={V}>
                <td className="p-2 text-white/60 text-xs font-medium whitespace-nowrap">{VLABEL[V]}</td>
                {cols.map((R) => {
                  const cell = data.matriz[V][R];
                  const cob = data.cobertura[V][R];
                  return (
                    <td key={R} className="p-1">
                      <button onClick={() => onCellClick && onCellClick({ vertical: VMAP[V], rol: RMAP[R] })}
                        className={`w-16 h-14 rounded flex flex-col items-center justify-center transition-transform hover:scale-105 ${cellStyle(V, R)}`}
                        title={`${VLABEL[V]} · ${R} · ${cell.crit === 'C' ? 'crítica' : cell.crit === 'A' ? 'apoyo' : 'no prioritaria'}`}>
                        <span className="text-sm font-medium">{cob}/{cell.min}</span>
                        <span className="text-[9px] opacity-60">{cell.crit === '—' ? '' : cell.crit}</span>
                      </button>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex gap-4 mt-3 text-[10px] text-white/40">
        <span><span className="inline-block w-3 h-3 rounded bg-emerald-400/20 align-middle mr-1" />Cubierta</span>
        <span><span className="inline-block w-3 h-3 rounded bg-amber-400/20 align-middle mr-1" />Déficit</span>
        <span><span className="inline-block w-3 h-3 rounded border-2 border-white/25 align-middle mr-1" />Crítica (C)</span>
      </div>

      <div className="mt-6 space-y-2">
        <p className="text-white/50 text-xs font-medium mb-2">Semáforo de apertura</p>
        {rows.map((V) => {
          const s = data.semaforo[V];
          const ok = s === 'LISTA PARA ABRIR';
          return (
            <div key={V} className="flex items-center gap-3">
              <span className="text-white/60 text-xs w-28">{VLABEL[V]}</span>
              <span className={`text-xs px-2 py-1 rounded ${ok ? 'bg-emerald-400/10 text-emerald-300' : 'bg-red-400/10 text-red-400'}`} data-testid={`semaforo-${V}`}>{s}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
